<template>
  <v-dialog v-model="is_open" fullscreen hide-overlay id="mail-dialog">
    <v-card>
      <v-toolbar dark color="primary">
          <v-toolbar-title>Contact</v-toolbar-title>
        </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex xs12>
            <v-text-field label="Destinataires" :value="recipientsFormat" readonly></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="CC" v-model="mail.cc"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="BCC" v-model="mail.bcc"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Sujet" v-model="mail.subject"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              :items=$store.state.moduleApplications.templates
              label="Type de réponse"
              item-text="title"
              item-value="title"
              v-model="mail.type"
              @change="updateMailContent"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="Contenu" v-model="mail.content" required rows="15"></v-textarea>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="closeDialog">Annuler</v-btn>
        <v-btn color="green" flat @click="sendMails">Envoyer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import preset_texts from '@/assets/presets_texts/index.js'

export default {
  name: 'mail-dialog',
  props: {
    opened: Boolean,
    to: Array
  },
  watch: {
    opened () {
      this.is_open = this.opened
      if (!this.is_open) {
        this.$emit('closed')
      } else {
        this.mail.to = this.to.map(a => a.applicant_mail)
        this.mail.jobs = this.to.map(a => a.job_full_value)
      }
    }
  },
  data() {  
    return {
      is_open: false,
      mail: {
        to: [],
        cc: "",
        bcc: "",
        subject: '',
        type: null,
        content: ''
      }
    }
  },
  watch: {
    opened(newVal) {
      this.is_open = newVal;
      if (newVal) {
        this.prepareMailData();
      }
    },
  },
  methods: {
    prepareMailData() {
      this.mail.to = this.to.map(a => a.applicant_mail);
      this.mail.jobs = this.to.map(a => a.job_full_value)
    },
    updateMailContent() {
      const templates = this.$store.state.moduleApplications.templates;
      const selectedTemplate = templates.find(template => template.title === this.mail.type);
      this.mail.subject = selectedTemplate.subject;
      this.mail.content = selectedTemplate ? selectedTemplate.content : '';
    },
    sendMails() {
      console.log("Envoi des mails", this.mail);
      this.$store.dispatch('moduleApplications/sendMails', this.mail);
      this.closeDialog();
    },
    closeDialog() {
      this.is_open = false;
      this.$emit('update:opened', false);
    }
  },
  computed: {
    recipientsFormat() {
      return this.mail.to.length > 1 ? `${this.mail.to[0]} et ${this.mail.to.length - 1} autre(s)` : this.mail.to[0];
    }
  }
}
</script>
